import React from "react";
import { LINKS, LOGOS } from "@/constants/links";
import { MessageCircle, Coffee } from "lucide-react";

export const Header = () => {
  return (
    <header
      data-testid="site-header"
      className="fixed top-0 left-0 right-0 z-40 border-b border-[#C9A87C]/10 bg-[#0A0908]/80 backdrop-blur-xl"
    >
      <div
        data-testid="construction-banner"
        className="border-b border-[#C9A87C]/15 bg-[#141311]/90"
      >
        <div className="mx-auto flex max-w-7xl items-center justify-center gap-3 px-6 py-2 text-center md:px-10">
          <span className="pulse-dot inline-block h-1.5 w-1.5 rounded-full bg-[#C9A87C]" />
          <p className="text-[10px] uppercase tracking-[0.28em] text-[#A39D95]">
            <span className="text-[#C9A87C]">The loom is still warming</span>
            <span className="mx-2 text-[#6E6A64]">·</span>
            This site is under construction — thanks for your patience
          </p>
        </div>
      </div>

      <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-4 md:px-10">
        <a
          href="#top"
          data-testid="site-header-brand"
          className="group flex items-center gap-3"
        >
          <img
            src={LOGOS.tapestryMark}
            alt=""
            aria-hidden="true"
            className="h-8 w-auto transition-transform duration-500 group-hover:-translate-y-0.5"
          />
          <span className="font-serif-display text-xl italic tracking-tight text-[#F2EFEB]">
            Tapestry
            <span className="text-[#C9A87C]">.</span>
            Games
          </span>
        </a>

        <nav className="hidden items-center gap-8 md:flex">
          <a
            href="#craft"
            data-testid="nav-craft"
            className="text-xs uppercase tracking-[0.28em] text-[#A39D95] transition-colors hover:text-[#C9A87C]"
          >
            The Craft
          </a>
          <a
            href="#games"
            data-testid="nav-games"
            className="text-xs uppercase tracking-[0.28em] text-[#A39D95] transition-colors hover:text-[#C9A87C]"
          >
            Games
          </a>
          <a
            href="#launch"
            data-testid="nav-launch"
            className="text-xs uppercase tracking-[0.28em] text-[#A39D95] transition-colors hover:text-[#C9A87C]"
          >
            Launch
          </a>
          <a
            href="#store"
            data-testid="nav-store"
            className="text-xs uppercase tracking-[0.28em] text-[#A39D95] transition-colors hover:text-[#C9A87C]"
          >
            Store
          </a>
          <a
            href="#newsletter"
            data-testid="nav-newsletter"
            className="text-xs uppercase tracking-[0.28em] text-[#A39D95] transition-colors hover:text-[#C9A87C]"
          >
            Dispatch
          </a>
        </nav>

        <div className="flex items-center gap-2">
          <a
            href={LINKS.buyMeACoffee}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="header-buymeacoffee"
            className="hidden h-9 w-9 items-center justify-center rounded-full border border-[#C9A87C]/25 text-[#C9A87C] transition-colors hover:border-[#C9A87C] hover:bg-[#C9A87C]/10 md:inline-flex"
            aria-label="Buy me a coffee"
            title="Buy me a coffee"
          >
            <Coffee className="h-4 w-4" />
          </a>
          <a
            href={LINKS.discord}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="header-discord"
            className="btn-primary !py-2 !text-[0.7rem]"
          >
            <MessageCircle className="h-4 w-4" /> Discord
          </a>
        </div>
      </div>
    </header>
  );
};

export default Header;
